var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"width":"800","title":"采购单品明细","footer-hide":true},model:{value:(_vm.ModalShow),callback:function ($$v) {_vm.ModalShow=$$v},expression:"ModalShow"}},[_c('Table',{attrs:{"size":"small","stripe":"","data":_vm.list,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }